import React from 'react';

const AboutSection = () => {
  const stats = [
    { number: '500K+', label: 'Tickets Sold' },
    { number: '50+', label: 'Cities Performed' },
    { number: '20+', label: 'Years Experience' },
    { number: '4', label: 'Magic Awards' }
  ];

  return (
    <section id="about" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative">
              <div className="aspect-square rounded-lg overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_reality-bender/artifacts/92df2lj2_simonthought.webp"
                  alt="Simon Nomis performing mind-reading magic"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-purple-600 rounded-full opacity-20"></div>
            </div>

            {/* Content */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-purple-400">SIMON</span> NOMIS
              </h2>
              
              <p className="text-xl text-gray-300 mb-6 leading-relaxed">
                Simon Nomis is a master magician, illusionist, and mentalist whose passion for the art of magic is as powerful as the illusions he creates. With over two decades of experience, Simon began his journey as a young boy, dedicating himself to honing his skills with relentless precision and artistry.
              </p>

              <p className="text-lg text-gray-400 mb-4 leading-relaxed">
                The true magic of a Simon Nomis performance, however, lies not just in the spellbinding feats, but in his infectious charisma and the palpable joy he radiates on stage. He has a unique gift for making every single audience member feel special, transforming them from passive spectators into the co-stars of the show. This deep connection ensures that no one is simply watching the magic—they are an essential part of it.
              </p>

              <p className="text-lg text-gray-400 mb-8 leading-relaxed">
                In 2026, Simon showcases his profound love for his craft by presenting two distinct and spectacular shows, each a testament to a different facet of his incredible talent. This dual-performance commitment demonstrates a dedication not just to amazing audiences, but to celebrating the vast and wonderful world of magic itself.
              </p>

              <div className="grid grid-cols-2 gap-6">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-2xl md:text-3xl font-bold text-purple-400 mb-2">
                      {stat.number}
                    </div>
                    <div className="text-sm text-gray-400 uppercase tracking-wider">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex flex-wrap gap-4">
                <span className="px-4 py-2 bg-purple-600/20 text-purple-400 rounded-full text-sm">
                  Grand Illusions
                </span>
                <span className="px-4 py-2 bg-purple-600/20 text-purple-400 rounded-full text-sm">
                  Mind Reading
                </span>
                <span className="px-4 py-2 bg-purple-600/20 text-purple-400 rounded-full text-sm">
                  Interactive Magic
                </span>
                <span className="px-4 py-2 bg-purple-600/20 text-purple-400 rounded-full text-sm">
                  Comedic Timing
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;